import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import PaymentRoot, { PaymentSuccess } from "./components/pages/PaymentRoot";
import StatementLookupPage from "./components/pages/StatementLookupPage";
import UnsubscribePage, { UnsubscribeCompletePage } from "./components/pages/UnsubscribePage";

import HCWHLogo from "./images/hcwh_logo_midgray_small_notext.png";

import './css/App.css';

function App() {
    return (
        <div className="app">
            <BrowserRouter>
                <Switch>
                    <Route path="/payment-success" component={PaymentSuccess} />
                    <Route path="/unsubscribe/success" component={UnsubscribeCompletePage} />
                    <Route path="/unsubscribe/:unsubId" component={UnsubscribePage} />
                    <Route path="/:statement_id" component={PaymentRoot} />
                    <Route path="/" exact={true} component={StatementLookupPage} />
                    <Route component={NotFound} />
                </Switch>
            </BrowserRouter>
        </div>
    );
}

function NotFound() {
    return <div className="box-light">
        <h1 className="no-top-margin">Not Found</h1>
        <p>
            We could not find the page you were looking for.
        </p>
        <p>
            Please make sure the link you followed is correct.
        </p>
        <footer className="image-footer">
            <img src={HCWHLogo} alt="Howard Center logo" />
        </footer>
    </div>;
}

export default App;
